import { BaseInfoModel } from 'app/core/models';
import { FabricationMethod } from 'app/core/enums';

export const FabricationMethodOptions: BaseInfoModel[] = [
  {
    id: FabricationMethod.selfPrint,
    name: 'general.selfPrint',
    tooltip: {
      title: 'general.selfPrint',
      body: {
        sections: [
          {
            description: 'messages.selfPrintDescription',
          },
        ],
      },
      placement: 'top',
    },
    hasInfo: true,
    imagePath: '',
  },
  {
    id: FabricationMethod.printAndShip,
    name: 'general.printAndShip',
    tooltip: {
      title: 'general.printAndShip',
      body: {
        sections: [
          {
            description: 'messages.printAndShipDescription',
          },
        ],
      },
      placement: 'top',
    },
    hasInfo: true,
    imagePath: '',
    subtitle: 'messages.printAndShipTimeNotes',
    subBoldText: 'messages.printAndShipServiceSpecificCountriesOnly',
  },
];
